import { ReCaptchaProvider } from '@circlefin/recaptcha/react'
import getConfig from 'next/config'

import type { NextConfig } from 'next/config'

import '@circlefin/recaptcha/css/styles.css'

const { publicRuntimeConfig } = getConfig() as NextConfig

export interface GoogleRecaptchaProviderProps {
  /**
   * React Node Children.
   */
  children?: React.ReactNode
}

export const GoogleRecaptchaProvider: React.FC<
  GoogleRecaptchaProviderProps
> = ({ children }) => {
  const siteKey = publicRuntimeConfig?.GOOGLE_RECAPTCHA_SITE_KEY as string
  const disabled = publicRuntimeConfig?.DISABLE_ASSESS_RISK_LEVEL === 'true'

  return (
    <ReCaptchaProvider disabled={disabled} siteKey={siteKey}>
      {children}
    </ReCaptchaProvider>
  )
}
